// Generated by purs version 0.14.4
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Semigroupoid from "../Control.Semigroupoid/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Function_Uncurried from "../Data.Function.Uncurried/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Record from "../Record/index.js";
import * as Record_Builder from "../Record.Builder/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var zipRecordNil = {
    zipRecordImpl: function (v) {
        return function (v1) {
            return function (v2) {
                return function (v3) {
                    return Control_Category.identity(Record_Builder.categoryBuilder);
                };
            };
        };
    }
};
var zipRecordImpl = function (dict) {
    return dict.zipRecordImpl;
};
var zipRecordCons = function (dictIsSymbol) {
    return function (dictCons) {
        return function (dictCons1) {
            return function (dictCons2) {
                return function (dictLacks) {
                    return function (dictZipRecord) {
                        return {
                            zipRecordImpl: function (v) {
                                return function (ra) {
                                    return function (v1) {
                                        return function (rb) {
                                            var tail = zipRecordImpl(dictZipRecord)(Type_Proxy["Proxy"].value)(ra)(Type_Proxy["Proxy"].value)(rb);
                                            var head = new Data_Tuple.Tuple(Record.get(dictIsSymbol)()(Type_Proxy["Proxy"].value)(ra), Record.get(dictIsSymbol)()(Type_Proxy["Proxy"].value)(rb));
                                            var first = Record_Builder.insert()()(dictIsSymbol)(Type_Proxy["Proxy"].value)(head);
                                            return Control_Semigroupoid.compose(Record_Builder.semigroupoidBuilder)(first)(tail);
                                        };
                                    };
                                };
                            }
                        };
                    };
                };
            };
        };
    };
};
var zipRecord = function (dictRowToList) {
    return function (dictRowToList1) {
        return function (dictZipRecord) {
            return function (ra) {
                return function (rb) {
                    var builder = zipRecordImpl(dictZipRecord)(Type_Proxy["Proxy"].value)(ra)(Type_Proxy["Proxy"].value)(rb);
                    return Record_Builder.build(builder)({});
                };
            };
        };
    };
};
var slToRlSNil = {};
var slToRlSCons = function (dictSListToRowList) {
    return {};
};
var sequenceRecordSingle = function (dictIsSymbol) {
    return function (dictCons) {
        return function (dictFunctor) {
            return function (dictLacks) {
                return function (dictCons1) {
                    return {
                        sequenceRecordImpl: function (v) {
                            return function (a) {
                                var valA = Record.get(dictIsSymbol)()(Type_Proxy["Proxy"].value)(a);
                                return Data_Functor.map(dictFunctor)(Record_Builder.insert()()(dictIsSymbol)(Type_Proxy["Proxy"].value))(valA);
                            };
                        },
                        Functor0: function () {
                            return dictFunctor;
                        }
                    };
                };
            };
        };
    };
};
var sequenceRecordNil = function (dictApplicative) {
    return {
        sequenceRecordImpl: function (v) {
            return function (v1) {
                return Control_Applicative.pure(dictApplicative)(Control_Category.identity(Record_Builder.categoryBuilder));
            };
        },
        Functor0: (dictApplicative.Apply0()).Functor0
    };
};
var sequenceRecordImpl = function (dict) {
    return dict.sequenceRecordImpl;
};
var sequenceRecordCons = function (dictIsSymbol) {
    return function (dictCons) {
        return function (dictApply) {
            return function (dictSequenceRecord) {
                return function (dictLacks) {
                    return function (dictCons1) {
                        return {
                            sequenceRecordImpl: function (v) {
                                return function (a) {
                                    var rest = sequenceRecordImpl(dictSequenceRecord)(Type_Proxy["Proxy"].value)(a);
                                    var valA = Record.get(dictIsSymbol)()(Type_Proxy["Proxy"].value)(a);
                                    var fn = function (valA$prime) {
                                        return function (rest$prime) {
                                            return Control_Semigroupoid.compose(Record_Builder.semigroupoidBuilder)(Record_Builder.insert()()(dictIsSymbol)(Type_Proxy["Proxy"].value)(valA$prime))(rest$prime);
                                        };
                                    };
                                    return Control_Apply.apply(dictApply)(Data_Functor.map(dictApply.Functor0())(fn)(valA))(rest);
                                };
                            },
                            Functor0: dictApply.Functor0
                        };
                    };
                };
            };
        };
    };
};
var sequenceRecord = function (dictRowToList) {
    return function (dictSequenceRecord) {
        return function (a) {
            var builder = sequenceRecordImpl(dictSequenceRecord)(Type_Proxy["Proxy"].value)(a);
            return Data_Functor.map(dictSequenceRecord.Functor0())(Data_Functor.flap(Data_Functor.functorFn)(Record_Builder.build)({}))(builder);
        };
    };
};
var ordRecordNil = {
    compareRecordImpl: function (v) {
        return function (v1) {
            return function (v2) {
                return Data_Ordering.EQ.value;
            };
        };
    }
};
var nilKeys = {
    keysImpl: function (v) {
        return Data_Monoid.mempty(Data_List_Types.monoidList);
    }
};
var mapRecordNil = {
    mapRecordBuilder: function (v) {
        return function (v1) {
            return function (v2) {
                return Control_Category.identity(Record_Builder.categoryBuilder);
            };
        };
    }
};
var mapRecordBuilder = function (dict) {
    return dict.mapRecordBuilder;
};
var mapRecordCons = function (dictIsSymbol) {
    return function (dictCons) {
        return function (dictMapRecord) {
            return function (dictLacks) {
                return function (dictCons1) {
                    return {
                        mapRecordBuilder: function (v) {
                            return function (f) {
                                return function (r) {
                                    var rest = mapRecordBuilder(dictMapRecord)(Type_Proxy["Proxy"].value)(f)(r);
                                    var val = f(Record.get(dictIsSymbol)()(Type_Proxy["Proxy"].value)(r));
                                    var first = Record_Builder.insert()()(dictIsSymbol)(Type_Proxy["Proxy"].value)(val);
                                    return Control_Semigroupoid.compose(Record_Builder.semigroupoidBuilder)(first)(rest);
                                };
                            };
                        }
                    };
                };
            };
        };
    };
};
var mapRecord = function (dictRowToList) {
    return function (dictMapRecord) {
        return function (f) {
            return function (r) {
                var builder = mapRecordBuilder(dictMapRecord)(Type_Proxy["Proxy"].value)(f)(r);
                return Record_Builder.build(builder)({});
            };
        };
    };
};
var keysImpl = function (dict) {
    return dict.keysImpl;
};
var slistKeys = function (dictSListToRowList) {
    return function (dictKeys) {
        return function (v) {
            return keysImpl(dictKeys)(Type_Proxy["Proxy"].value);
        };
    };
};
var keys = function (dictRowToList) {
    return function (dictKeys) {
        return function (v) {
            return keysImpl(dictKeys)(Type_Proxy["Proxy"].value);
        };
    };
};
var pick = function (dictUnion) {
    return function (dictRowToList) {
        return function (dictKeys) {
            var ks = Data_Array.fromFoldable(Data_List_Types.foldableList)(keys()(dictKeys)(Type_Proxy["Proxy"].value));
            return Data_Function_Uncurried.runFn2($foreign.pickFn)(ks);
        };
    };
};
var consKeys = function (dictIsSymbol) {
    return function (dictKeys) {
        return {
            keysImpl: function (v) {
                var rest = keysImpl(dictKeys)(Type_Proxy["Proxy"].value);
                var first = Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value);
                return new Data_List_Types.Cons(first, rest);
            }
        };
    };
};
var compareRecordImpl = function (dict) {
    return dict.compareRecordImpl;
};
var ordRecordCons = function (dictIsSymbol) {
    return function (dictOrd) {
        return function (dictCons) {
            return function (dictOrdRecord) {
                return {
                    compareRecordImpl: function (v) {
                        return function (a) {
                            return function (b) {
                                var valA = Record.get(dictIsSymbol)()(Type_Proxy["Proxy"].value)(a);
                                var valB = Record.get(dictIsSymbol)()(Type_Proxy["Proxy"].value)(b);
                                var v1 = Data_Ord.compare(dictOrd)(valA)(valB);
                                if (v1 instanceof Data_Ordering.EQ) {
                                    return compareRecordImpl(dictOrdRecord)(Type_Proxy["Proxy"].value)(a)(b);
                                };
                                return v1;
                            };
                        };
                    }
                };
            };
        };
    };
};
var compareRecord = function (dictRowToList) {
    return function (dictOrdRecord) {
        return function (a) {
            return function (b) {
                return compareRecordImpl(dictOrdRecord)(Type_Proxy["Proxy"].value)(a)(b);
            };
        };
    };
};
export {
    pickFn
} from "./foreign.js";
export {
    compareRecordImpl,
    keysImpl,
    mapRecordBuilder,
    sequenceRecordImpl,
    zipRecordImpl,
    mapRecord,
    zipRecord,
    keys,
    pick,
    slistKeys,
    compareRecord,
    sequenceRecord,
    mapRecordCons,
    mapRecordNil,
    zipRecordNil,
    zipRecordCons,
    nilKeys,
    consKeys,
    slToRlSNil,
    slToRlSCons,
    ordRecordCons,
    ordRecordNil,
    sequenceRecordSingle,
    sequenceRecordCons,
    sequenceRecordNil
};
//# sourceMappingURL=index.js.map
